import { cn } from "@/lib/utils";

export const pillGroupClass =
  "flex h-11 items-center gap-0.5 rounded-full bg-card p-1 max-md:max-w-full max-md:overflow-x-auto max-md:[scrollbar-width:none]";

export const compactGroupClass = "flex h-9 items-center gap-0.5 rounded-full bg-muted/70 p-1";

export const pillItemClass = (on: boolean, compact?: boolean) =>
  cn(
    "inline-flex min-w-9 shrink-0 items-center justify-center gap-2 rounded-full px-4 text-sm font-medium whitespace-nowrap transition-[background-color,color,box-shadow] duration-200 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    compact ? "h-7 !px-3 text-[13px]" : "h-9",
    on ? "bg-foreground text-background shadow-sm" : "text-muted-foreground hover:bg-secondary/60 hover:text-foreground",
  );

export const secondaryPillClass =
  "inline-flex h-11 shrink-0 items-center gap-2 rounded-full bg-card px-5 text-sm font-medium text-foreground transition-colors duration-150 outline-none hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50";

/** Select trigger styled as a pill; pass to `SelectTrigger className`. */
export const selectPillClass = "bg-card px-4 data-[size=default]:h-10 hover:bg-accent";
